import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../shared/axiosBaseQuery';
import Environment from '../../shared/constants/Environment';

const authBaseUrl = Environment.backendAPIAuth;

const AuthAPI = createApi({
  reducerPath: 'authAPI',
  baseQuery: axiosBaseQuery({ baseUrl: authBaseUrl }),
  tagTypes: ['auth-config'],
  endpoints: () => ({}),
});

export default AuthAPI;
